import { useForm, ValidationError } from "@formspree/react";

export default function ContactSection() {
  const [state, handleSubmit] = useForm("xgvapkbo"); // Replace with your Formspree ID

  if (state.succeeded) {
    return (
      <section className="py-10 bg-white overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="py-16 px-8 bg-gray-100 overflow-hidden rounded-3xl">
            <div className="max-w-5xl mx-auto text-center">
              <h2 className="font-heading mb-6 text-4xl text-gray-900 font-black tracking-tight">
                Thank you!
              </h2>
              <p className="text-gray-500 font-bold">
                Your message has been received. We’ll get back to you soon!
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-10 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="py-16 px-8 bg-gray-100 overflow-hidden rounded-3xl">
          <div className="max-w-5xl mx-auto">
            <div className="mb-10 md:max-w-md mx-auto text-center">
              <span className="inline-block mb-4 text-sm text-blue-500 font-bold uppercase tracking-widest">
                Contact Us
              </span>
              <h2 className="font-heading mb-6 text-4xl md:text-5xl lg:text-6xl text-gray-900 font-black tracking-tight">
                Get connected
              </h2>
              <p className="text-gray-500 font-bold">
                Want to provide feedback or just have questions about the app before you join the waitlist? Contact us here!
              </p>
            </div>
            <form
              className="p-10 bg-white border border-gray-100 rounded-3xl"
              onSubmit={handleSubmit}
            >
              <div className="flex flex-wrap -m-5 mb-1">
                <div className="w-full md:w-1/2 p-5">
                  <label
                    className="block mb-2 text-sm text-gray-500 font-bold"
                    htmlFor="name"
                  >
                    Full Name
                  </label>
                  <input
                    className="appearance-none px-6 py-3.5 w-full text-lg text-gray-500 font-bold bg-gray-100 placeholder-gray-500 outline-none focus:ring-4 focus:ring-blue-200 rounded-full"
                    id="name"
                    type="text"
                    name="name"
                    required
                  />
                  <ValidationError prefix="Name" field="name" errors={state.errors} />
                </div>
                <div className="w-full md:w-1/2 p-5">
                  <label
                    className="block mb-2 text-sm text-gray-500 font-bold"
                    htmlFor="email"
                  >
                    Email address
                  </label>
                  <input
                    className="appearance-none px-6 py-3.5 w-full text-lg text-gray-500 font-bold bg-gray-100 placeholder-gray-500 outline-none focus:ring-4 focus:ring-blue-200 rounded-full"
                    id="email"
                    type="email"
                    name="email"
                    required
                  />
                  <ValidationError prefix="Email" field="email" errors={state.errors} />
                </div>
              </div>
              <div className="flex flex-wrap -m-5">
                <div className="w-full md:w-1/2 p-5">
                  <label
                    className="block mb-2 text-sm text-gray-500 font-bold"
                    htmlFor="phone"
                  >
                    Phone
                  </label>
                  <input
                    className="appearance-none px-6 py-3.5 w-full text-lg text-gray-500 font-bold bg-gray-100 placeholder-gray-500 outline-none focus:ring-4 focus:ring-blue-200 rounded-full"
                    id="phone"
                    type="text"
                    name="phone"
                  />
                  <ValidationError prefix="Phone" field="phone" errors={state.errors} />
                </div>
                <div className="w-full md:w-1/2 p-5">
                  <label
                    className="block mb-2 text-sm text-gray-500 font-bold"
                    htmlFor="subject"
                  >
                    Subject
                  </label>
                  <input
                    className="appearance-none px-6 py-3.5 w-full text-lg text-gray-500 font-bold bg-gray-100 placeholder-gray-500 outline-none focus:ring-4 focus:ring-blue-200 rounded-full"
                    id="subject"
                    type="text"
                    name="subject"
                  />
                  <ValidationError prefix="Subject" field="subject" errors={state.errors} />
                </div>
              </div>
              <div className="flex flex-wrap -m-3.5">
                <div className="w-full p-3.5">
                  <label
                    className="block mb-2 text-sm text-gray-500 font-bold"
                    htmlFor="message"
                  >
                    Message
                  </label>
                  <textarea
                    className="appearance-none px-6 py-5 w-full text-lg text-gray-500 font-bold bg-gray-100 placeholder-gray-500 outline-none focus:ring-4 focus:ring-blue-200 rounded-3xl"
                    id="message"
                    name="message"
                    rows="8"
                    required
                  ></textarea>
                  <ValidationError prefix="Message" field="message" errors={state.errors} />
                </div>
                <div className="w-full p-3.5">
                  <div className="flex flex-wrap items-center -m-2">
                    <div className="w-full md:w-1/2 p-2"></div>
                    <div className="w-full md:w-1/2 p-2">
                      <div className="flex flex-wrap md:justify-end -m-2">
                        <div className="w-full md:w-auto p-2">
                          <button
                            type="submit"
                            disabled={state.submitting}
                            className="block w-full px-8 md:px-16 py-3.5 text-lg text-center text-white font-bold bg-blue-500 hover:bg-blue-600 focus:ring-4 focus:ring-blue-200 rounded-full"
                          >
                            {state.submitting ? "Sending..." : "Send Message"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            {/* Add social/contact options below if needed */}
          </div>
        </div>
      </div>
    </section>
  );
}
